import { render, staticRenderFns } from "./SettingsMachineTab.vue?vue&type=template&id=5db89a6d"
import script from "./SettingsMachineTab.vue?vue&type=script&lang=ts"
export * from "./SettingsMachineTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports